/* Live prices and availability are rendered by Shopify; approved specifications are SKU-bound. */
(() => {
  const attributes={"cabinet":"Spintelės plotis, mm","height":"Sistemos aukštis, mm","cabinetDepth":"Spintelės gylis, mm","drawerDepth":"Stalčiaus gylis, mm","colour":"Spalva","count":"Dėžių skaičius, vnt.","vendor":"Gamintojas"};
  const keys=[...Object.keys(attributes),'availability','min','max','sort'];
  const lightColourRank = variant => ({magnolia:0,day:1,polaris:2}[variant.title.trim().toLowerCase()] ?? 100);
  const selectedValues = value => Array.isArray(value) ? value : value ? [value] : [];
  function matches(variant, state) {
    const a = variant.attributes;
    return Object.entries(attributes).every(([key,label])=>!selectedValues(state[key]).length||selectedValues(state[key]).includes(String(a[label]??'')))
      && (!state.availability || variant.available === (state.availability === 'stock'))
      && (!state.min || variant.price >= Number(state.min) * 100)
      && (!state.max || variant.price <= Number(state.max) * 100);
  }
  // Cabinet width is the primary constraint. Keep the latest choice and remove
  // stale dependent dimensions, never combining attributes of different variants.
  function reconcile(variants, state, changed) {
    const accepted = {};
    const priority = [...new Set(['cabinet', changed, ...Object.keys(attributes)])].filter(key=>key in attributes);
    for (const key of priority) {
      const values = selectedValues(state[key]).filter(value=>variants.some(v=>matches(v,{...accepted,[key]:value})));
      accepted[key] = key==='height' ? values : values[0] || '';
    }
    return {...state,...accepted};
  }
  function facetValues(variants, state, key) {
    const context = key==='cabinet' ? {} : {...state,[key]:'',availability:'',min:'',max:''};
    return [...new Set(variants.filter(v=>matches(v,context)).map(v=>String(v.attributes[attributes[key]]??'')).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt',{numeric:true}));
  }
  class SinkFilters extends HTMLElement {
    static matches(variant,state){return matches(variant,state);}
    static reconcile(variants,state,changed){return reconcile(variants,state,changed);}
    static facetValues(variants,state,key){return facetValues(variants,state,key);}
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.grid = this.querySelector('.schock-sink-grid');
      this.cards = [...this.querySelectorAll('[data-sink-card]')].map((node,index) => ({
        node,index,variants:JSON.parse(node.querySelector('[data-sink-variants]').textContent),
        links:[...node.querySelectorAll('a[href*="/products/"]')].map(link=>({link,href:link.getAttribute('href')})),
        image:node.querySelector('.card__media img'),
        originalImage:node.querySelector('.card__media img')?.outerHTML,
        priceNode:node.querySelector('.price'),
        originalPrice:node.querySelector('.price')?.innerHTML,
        stockNode:node.querySelector('[data-stock-status]'),
        originalStock:node.querySelector('[data-stock-status]')?.innerHTML
      }));
      this.variants=this.cards.flatMap(c=>c.variants);
      for(const [key,label] of Object.entries(attributes)){
        const allowed=key==='drawerDepth'?this.dataset.category!=='istraukiamos-siuksliadezes-spintelems'&&this.dataset.category!=='kitos-siuksliadezes':key==='cabinetDepth'?this.dataset.category!=='siuksliadezes-stalciams':true;
        const values=[...new Set(this.cards.flatMap(c=>c.variants.map(v=>String(v.attributes[label]??''))).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt',{numeric:true}));
        const field=this.querySelector(`[data-filter-field="${key}"]`);
        if(key==='height'){
          for(const value of values){
            const option=document.createElement('label');
            const checkbox=document.createElement('input');checkbox.type='checkbox';checkbox.name=key;checkbox.value=value;
            const text=document.createElement('span');text.textContent=value;
            option.append(checkbox,text);field.querySelector('[data-height-options]').append(option);
          }
          field.hidden=!values.length;
          continue;
        }
        const select=this.form.elements[key];
        for(const value of values){const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);}
        if(!allowed||!values.length){field.hidden=true;select.disabled=true;}
      }
      this.readURL(); this.apply(false); this.form.hidden = false;
      this.form.addEventListener('change',e=>this.apply(true,e.target.name));
      this.form.addEventListener('input',e=>{if(e.target.type==='number')this.apply(true);});
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('reset',()=>setTimeout(()=>this.apply(true),0));
      this.onPop=()=>{this.readURL();this.apply(false);};
      window.addEventListener('popstate',this.onPop);
    }
    disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
    readURL(){
      const params=new URL(location.href).searchParams;
      for(const key of keys){
        if(key==='height'){this.form.querySelectorAll('[name="height"]').forEach(input=>{input.disabled=false;input.checked=params.getAll('s_height').includes(input.value);});}
        else {const input=this.form.elements[key];if(input.options)for(const option of input.options)option.disabled=false;input.value=params.get('s_'+key)|| (key==='sort'?'default':'');}
      }
    }
    updateFacets(state){
      for(const key of Object.keys(attributes)){
        const values=facetValues(this.variants,state,key);
        if(key==='height'){
          this.form.querySelectorAll('[name="height"]').forEach(input=>{
            input.checked=state.height.includes(input.value);
            input.disabled=!values.includes(input.value);input.closest('label').hidden=input.disabled;
          });
        }else{
          const select=this.form.elements[key];select.value=state[key]||'';
          for(const option of select.options){option.disabled=!!option.value&&!values.includes(option.value);option.hidden=option.disabled;}
        }
      }
    }
    apply(writeURL,changed){
      const data=new FormData(this.form);
      const state=reconcile(this.variants,{...Object.fromEntries(data),height:data.getAll('height')},changed);
      this.updateFacets(state);
      const constrained=keys.some(k=>k!=='sort'&&selectedValues(state[k]).length);
      let count=0;
      const cards=this.cards.map(card=>{
        const variants=card.variants.filter(v=>matches(v,state));
        card.node.hidden=variants.length===0;
        if(variants.length)count++;
        const matched=[...variants].sort((a,b)=>Number(b.available)-Number(a.available)||lightColourRank(a)-lightColourRank(b))[0];
        const note=card.node.querySelector('[data-filter-match]');
        note.hidden=!constrained||!matched;
        note.textContent=matched ? `Atitinka: ${variants.map(v=>v.title).join(', ')}` : '';
        for(const {link,href} of card.links){const url=new URL(href,location.origin);if(matched)url.searchParams.set('variant',matched.id);link.setAttribute('href',matched?url.pathname+url.search:href);}
        if(card.image){
          if(matched?.image){card.image.src=matched.image;card.image.removeAttribute('srcset');card.image.alt=`${card.node.dataset.title}${matched.title==='Default Title'?'':' – '+matched.title}`;}
          else if(card.originalImage){card.image.outerHTML=card.originalImage;card.image=card.node.querySelector('.card__media img');}
        }
        if(card.priceNode){
          if(matched)card.priceNode.textContent=new Intl.NumberFormat('lt-LT',{style:'currency',currency:'EUR'}).format(matched.price/100);
          else card.priceNode.innerHTML=card.originalPrice;
        }
        if(card.stockNode){
          if(matched){
            card.stockNode.textContent=matched.delivery || (matched.available?'Pristatymas iki 3 darbo dienų':'Pristatymas iki 4 savaičių');
            const colour=document.createElement('small');colour.textContent=matched.title==='Default Title'?'':matched.title;card.stockNode.append(colour);
          }
          else card.stockNode.innerHTML=card.originalStock;
        }
        return {...card,inStock:variants.some(v=>v.available),price:variants.length?Math.min(...variants.map(v=>v.price)):Infinity};
      });
      cards.sort((a,b)=>state.sort==='price-asc'?a.price-b.price:state.sort==='price-desc'?b.price-a.price:state.sort==='title'?a.node.dataset.title.localeCompare(b.node.dataset.title,'lt'):Number(b.inStock)-Number(a.inStock)||a.index-b.index);
      cards.forEach(c=>this.grid.append(c.node));
      this.querySelector('[data-filter-count]').textContent=`Rodoma modelių: ${count} iš ${cards.length}`;
      this.querySelector('[data-filter-empty]').hidden=count!==0;
      if(writeURL){const url=new URL(location.href);for(const key of keys){url.searchParams.delete('s_'+key);for(const value of selectedValues(state[key]))if(value!=='default')url.searchParams.append('s_'+key,value);}if(url.href!==location.href)history.pushState({},'',url);}
    }
  }
  if(!customElements.get('furnitanas-bin-filters'))customElements.define('furnitanas-bin-filters',SinkFilters);
})();
